package br.com.texeratx.boardgametimeapp.ui.spotifydevices

import br.com.texeratx.boardgametimeapp.core.i18n.LanguageManager
import br.com.texeratx.boardgametimeapp.core.spotify.auth.SpotifyAuthException
import br.com.texeratx.boardgametimeapp.core.spotify.repository.SpotifyPlayerRepository
import cafe.adriel.voyager.core.model.ScreenModel
import cafe.adriel.voyager.core.model.screenModelScope
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.launch

class SpotifyDevicesViewModel(
    private val repo: SpotifyPlayerRepository,
    private val lang: LanguageManager
) : ScreenModel {

    private val _state = MutableStateFlow(SpotifyDevicesUiState())
    val state: StateFlow<SpotifyDevicesUiState> = _state

    fun refreshDevices() {
        screenModelScope.launch {
            _state.value = _state.value.copy(isLoading = true, error = null)

            repo.listDevices().fold(
                onSuccess = { devices ->
                    // Seleção default:
                    // 1) se já tem selectedDeviceId e ainda existe, mantém
                    // 2) senão, escolhe o ativo
                    // 3) senão, escolhe o primeiro com id
                    val currentSelected = _state.value.selectedDeviceId
                    val stillExists = devices.any { it.id != null && it.id == currentSelected }

                    val defaultId =
                        if (stillExists) currentSelected
                        else devices.firstOrNull { it.isActive && it.id != null }?.id
                            ?: devices.firstOrNull { it.id != null }?.id

                    _state.value = _state.value.copy(
                        isLoading = false,
                        devices = devices,
                        selectedDeviceId = defaultId,
                        error = null
                    )
                },
                onFailure = { e ->
                    val message = when {
                        e is SpotifyAuthException && e.reason == SpotifyAuthException.Reason.RECONNECT_REQUIRED ->
                            lang.strings.value.spotifyReconnectRequired
                        else -> lang.strings.value.unknownError
                    }

                    _state.value = _state.value.copy(
                        isLoading = false,
                        error = message
                    )
                }
            )
        }
    }

    fun selectDevice(deviceId: String?) {
        _state.value = _state.value.copy(selectedDeviceId = deviceId)
    }

    fun selectedDeviceIdOrNull(): String? = _state.value.selectedDeviceId
}
